import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { LanguageConsumer } from './lib/LanguageContext'
import './Sidebar.css';


class Sidebar extends Component {

    render() {
        return(
         <LanguageConsumer> 
            {({polyglot}) =>
                (<nav className={`sidebar ${this.props.showHideNav}`}>
                <ul>
                  <li>
                    <NavLink className="sidebar-item" to="/overview/all" activeClassName="active" onClick={() => {this.props.handleClick()}}>
                      <span className="navlink-body"> <span className="fa fa-chart-bar"></span> {polyglot.t('overview')}</span>
                    </NavLink> 
                  </li>
                  <li> 
                    <NavLink className="sidebar-item" to="/results" activeClassName="active" onClick={() => {this.props.handleClick()}}>
                      <span className="navlink-body"> <span className="fa fa-check"></span> {polyglot.t('checks')}</span>
                    </NavLink>
                  </li>
                </ul>
            </nav>)}
         </LanguageConsumer>
       )
    }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/Sidebar.js